import React, { Component } from 'react'
import Header from './components/Header/Header'
import Home from './container/Home/Home'
import {withStyles} from '@material-ui/core'
import { Route, Switch } from 'react-router-dom'
import Uploader from './container/Uploader/Uploader'
import Details from './container/Details/Details'
import Settings from './container/Settings/Settings'
import Edit from './container/Edit/Edit'
const styles = {};

class App extends Component {
    render() {
        return (
            <div>
                <Header />
                <Switch>
                    <Route exact path="/" component={Home} />
                    <Route exact path="/create" component={Uploader} />
                    <Route exact path="/conf" component={Settings} />
                    <Route exact path="/:id(\d+)" component={Details} />
                    <Route exact path="/:id(\d+)/edit" component={Edit} />
                </Switch>
            </div>
        );
    }

}

export default withStyles(styles)(App);
